import { valorNumérico } from 'src/app/compartido/utilidades/valores.utils';
import { PrototipoColumna } from './archivo-ordenes.models';
import { OPCIONES_TIPO_IDENTIFICACION_FORMULARIO } from 'src/app/compartido/formulario/utilidades/formulario.static';

/* Todas la columnas relevantes en el archivo */
export const COLUMNAS_ARCHIVO_ORDEN: PrototipoColumna[] = [
  {
    slug: 'enumeracion',
    descripcion: 'Enumeración/Ítem de la orden',
    palabras: ['item', 'enumeracion'],
    requerida: false,
  },
  {
    slug: 'tipo',
    descripcion: 'Tipo de entrega',
    palabras: ['tipo'],
    requerida: false,
    matchExacto: true,
    validador: (valor: string) => {
      if (!['normal', 'volumen'].includes(valor.toLowerCase()))
        return 'Valor inválido (Las opciones son: Normal o Volumen)';
      return null;
    },
  },
  {
    slug: 'prioridad',
    descripcion: 'Prioridad de la orden',
    palabras: ['prioridad'],
    requerida: false,
    validador: (valor: string) => {
      if (!['same_day', 'next_day'].includes(valor.toLowerCase()))
        return 'Valor inválido (Las opciones son: Same_day o Next_day)';
      return null;
    },
  },
  {
    slug: 'referencia',
    descripcion: 'N° de referencia de la orden',
    palabras: [
      'no ssc',
      'numero de pedido',
      'orden',
      'factura',
      'referencia',
      'formula',
    ],
    requerida: true,
  },
  {
    slug: 'servicio',
    descripcion: 'Servicio por el cual se genera la orden',
    palabras: ['servicio'],
    requerida: false,
    validador: (valor: string) => {
      if (!['Pendiente', 'PQR', 'Sala', 'PAC'].includes(valor))
        return 'Valor inválido (Las opciones son: Pendiente, PQR, Sala o PAC)';
      return null;
    },
  },
  {
    slug: 'identificacion',
    descripcion: 'Identificación del paciente',
    palabras: ['identificacion', 'cedula', 'numero documento', 'documento'],
    requerida: true,
  },
  {
    slug: 'tipo_identificacion',
    descripcion: 'Tipo de identificación del paciente',
    palabras: ['tipo identificacion', 'tipo documento'],
    requerida: false,
    validador: (valor: string) => {
      const opciones = OPCIONES_TIPO_IDENTIFICACION_FORMULARIO.map(
        (opcion) => opcion.valor,
      );
      const incluye = opciones.includes(valor);
      if (!incluye)
        return `Valor inválido (Las opciones son: ${opciones.join(', ')})`;
      return null;
    },
  },
  {
    slug: 'nombre',
    descripcion: 'Nombre del paciente',
    palabras: ['nombre beneficiario', 'nombre', 'columna1'],
    requerida: true,
  },
  {
    slug: 'direccion',
    descripcion: 'Dirección de la residencia del paciente',
    palabras: ['direccion residencia', 'direccion'],
    requerida: true,
  },
  {
    slug: 'detalles',
    descripcion: 'Detalles de la dirección del paciente',
    palabras: ['detalles', 'detalle'],
    requerida: false,
  },
  {
    slug: 'barrio',
    descripcion: 'Barrio de residencia del paciente',
    palabras: ['barrio'],
    requerida: false,
  },
  {
    slug: 'localidad',
    descripcion: 'Localidad de residencia del paciente',
    palabras: ['localidad'],
    requerida: false,
  },
  {
    slug: 'ciudad',
    descripcion: 'Ciudad de residencia del paciente',
    palabras: ['ciudad'],
    requerida: true,
  },
  {
    slug: 'latitud',
    descripcion: 'Latitud de la residencia del paciente',
    palabras: ['latitud'],
    requerida: false,
  },
  {
    slug: 'longitud',
    descripcion: 'Longitud de la residencia del paciente',
    palabras: ['longitud'],
    requerida: false,
  },
  {
    slug: 'telefono',
    descripcion: 'Teléfono de contacto del paciente',
    palabras: ['telefono', 'contacto', 'celular'],
    requerida: false,
    matchExacto: true,
  },
  {
    slug: 'correo',
    descripcion: 'Correo electrónico del paciente',
    palabras: ['correo'],
    requerida: false,
    validador: (valor: string) => {
      if (!valor.includes('@'))
        return 'Formato inválido (Debe ser un correo electrónico)';
      return null;
    },
  },
  {
    slug: 'notas',
    descripcion: 'Notas adicionales de la orden',
    palabras: ['notas'],
    requerida: false,
  },
  {
    slug: 'centro_costo',
    descripcion: 'Centro de costo de la orden',
    palabras: ['centro de costo', 'centro costo'],
    requerida: false,
  },
  {
    slug: 'recaudo',
    descripcion: 'Monto de recaudo de la orden',
    palabras: ['recaudo'],
    requerida: false,
    validador: (valor: string) => {
      if (valorNumérico(valor) === undefined)
        return 'Formato inválido (Debe ser un número)';
      return null;
    },
  },
  {
    slug: 'carga',
    descripcion: 'Tipo de carga de la orden',
    palabras: ['carga'],
    requerida: false,
  },
  {
    slug: 'unidades',
    descripcion: 'Número de unidades de carga de la orden',
    palabras: ['unidades', 'cantidad pendiente', 'cantidad'],
    requerida: false,
    validador: (valor: string) => {
      const valores = valor.split(',');
      for (const val of valores) {
        if (valorNumérico(valor) === undefined)
          return 'Formato inválido (Debe ser uno o más números)';
      }
      return null;
    },
  },
];
